<app-admin-menu></app-admin-menu>

<h1 class="mat-headline-3">Tilldela anställda för kostnadsställen</h1>

<div class="container">
    <div class="row">
        <div class="col">
            <mat-card class="compact employee-cost-pool-handled-by">
                <mat-card-content>
                    <app-employee-cost-pool-handled-by (filterChanged)="updateQueryParameters($event)"
                        [page]="page" [companyId]="companyId" [status]="status"></app-employee-cost-pool-handled-by>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<app-messages #messagesPartial [employeeId]="employeeId"></app-messages>

<app-admin-footer></app-admin-footer>
